"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    if (!await knex.schema.hasTable(_globals.MetaTable.RECORD_TEMPLATES)) {
        await knex.schema.createTable(_globals.MetaTable.RECORD_TEMPLATES, (table)=>{
            table.string('id', 20).notNullable();
            table.string('base_id', 20).notNullable().index();
            table.string('fk_workspace_id', 20).index();
            table.string('fk_model_id', 20).notNullable().index();
            table.string('title', 255).notNullable();
            table.text('description');
            table.text('template_data', 'mediumtext').notNullable();
            table.integer('usage_count').defaultTo(0);
            table.boolean('enabled').defaultTo(true);
            table.string('created_by', 20);
            table.timestamps(true, true);
            table.primary([
                'base_id',
                'id'
            ]);
        });
    }
};
const down = async (knex)=>{
    await knex.schema.dropTableIfExists(_globals.MetaTable.RECORD_TEMPLATES);
};
